import { h } from 'preact'
import { useEffect, useRef } from 'preact/hooks'

const CHAR_DELAY_MS = 38

/**
 * ConversationTitle — typewriter animation for conversation title.
 * Mounted separately into the page header title element.
 *
 * Props: { store }
 */
export function ConversationTitle({ store }) {
  const title   = store.title.value
  const spanRef = useRef(null)
  const prevRef = useRef('')

  useEffect(() => {
    if (!title || title === prevRef.current) return
    prevRef.current = title

    const el = spanRef.current
    if (!el) return

    // Update page <title> too
    document.title = title

    // Typewriter animation
    el.textContent = ''
    el.classList.add('ai-title-typewriter')
    const chars = [...title]
    let i = 0
    const type = () => {
      if (i < chars.length) {
        el.textContent += chars[i++]
        setTimeout(type, CHAR_DELAY_MS)
      } else {
        el.classList.remove('ai-title-typewriter')
      }
    }
    type()
  }, [title])

  return <span ref={spanRef}>{title}</span>
}
